module.exports = __webpack_public_path__ + "static/media/update-arrow.748a6089.svg";